/**
 * @license lucide-react v0.503.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createLucideIcon from '../createLucideIcon.js';

const __iconNode = [
  ["path", { d: "M19 15V9", key: "1hci5f" }],
  ["path", { d: "M15 15h-3v4l-7-7 7-7v4h3v6z", key: "16tjna" }]
];
const ArrowBigLeftDash = createLucideIcon("arrow-big-left-dash", __iconNode);

export { __iconNode, ArrowBigLeftDash as default };
//# sourceMappingURL=arrow-big-left-dash.js.map
